import { render, staticRenderFns } from "./collection-order.vue?vue&type=template&id=13750116&scoped=true&"
import script from "./collection-order.vue?vue&type=script&lang=ts&"
export * from "./collection-order.vue?vue&type=script&lang=ts&"
import style0 from "./collection-order.vue?vue&type=style&index=0&id=13750116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13750116",
  null
  
)

export default component.exports